import { useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";

/**
 * Disables right-click context menu and DevTools shortcuts for non-admin users.
 * Admins (super_admin / admin) keep full browser capabilities.
 * Must be rendered inside <AuthProvider>.
 */
export function ContextMenuGuard() {
  const { isAdmin, loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (isAdmin) return; // Admins: no restrictions

    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      return false;
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "F12") {
        e.preventDefault();
        return false;
      }
      if (e.ctrlKey && e.key === "u") {
        e.preventDefault();
        return false;
      }
      if (e.ctrlKey && e.key === "s") {
        e.preventDefault();
        return false;
      }
      if (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J" || e.key === "C")) {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isAdmin, loading]);

  return null;
}
